import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import { ServiceObject } from "../../models/service-object";

@Injectable()
export class ObjectControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getServiceObject(serviceId: string, fieldKey: string): Observable<ServiceObject> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/object/" + fieldKey) as Observable<ServiceObject>;
  }
}
